export default __webpack_public_path__ + "static/latency-mobile1-559509739598e60289ed28f5463eecad.png";